import { render } from "./InputShares.vue?vue&type=template&id=5c85d1ed"
import script from "./InputShares.vue?vue&type=script&lang=js"
export * from "./InputShares.vue?vue&type=script&lang=js"

import "./InputShares.vue?vue&type=style&index=0&id=5c85d1ed&lang=scss"
script.render = render

export default script